export const CDN_URL = 'https://cdn.n37z.com';
